import { createComponent as cc } from 'react-fela';
import { Link } from 'react-router-dom';

const LinkWithoutDecoration = cc(
  () => ({
    textDecoration: 'none',
  }),
  Link,
  ['to', 'onClick'],
);

export default LinkWithoutDecoration;



// WEBPACK FOOTER //
// ./src/components/wrappers/LinkWithoutDecoration.js